import { UiArrowExpandIcon } from '@octane/spark'
import styled from 'styled-components'

import { DropdownContent } from '../../../assets/styles/dropdown'
import { NavbarItemStyled } from '../NavbarItem/NavbarItem.styled'

export const NavbarDropdownContent = styled(DropdownContent)`
    position: absolute;
    top: 100%;
    right: 20px;
    background: white;
    z-index: 100;
    color: ${(props) => props.theme.colors.monochrome.ravenSub};
`

export const NavbarDropdownIcon = styled(UiArrowExpandIcon)`
    margin-top: 3px;
    display: inline-block;
    position: absolute;
`

export const NavbarDropdownItem = styled(NavbarItemStyled)`
    width: 75px;
    flex-direction: column;
    align-items: center;
`
